import React from 'react'
import './Footer.css'
function Footer() {
  return (
    <>
        <div className="footer">
            <div className="container">
                <h1>©2022 All Rights Reserved <a href="#section">Eslam Elhadi<span>dy</span></a>.</h1>
            </div>
        </div>
    </>
  )
}

export default Footer